export default __webpack_public_path__ + "static/media/Logo.a8c9bb9d.png";